module.exports = ".dashboardtable {\n  min-height: 160px;\n  max-height: 160px;\n  width: 73%; }\n\n.line {\n  background-color: #ff8ba4a8;\n  height: 2px;\n  margin-top: 2px; }\n\n.gridLines {\n  color: \"#FFFFFF\"; }\n\n.ngx-gauge-meter {\n  height: 110px !important; }\n\n.reading-block {\n  font-size: 28px !important;\n  line-height: 180px !important; }\n\n.table-bordered {\n  width: 67%;\n  border-right: 1px solid #fff !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/dashboard/dashboard.component.scss
// module id = ./client/app/dashboard/dashboard.component.scss
// module chunks = main